import React from 'react';
import VideoCard from "./videoCard";

const videoData = [
  {
    title: 'AgriPix Image to Prompt',
    url: 'https://youtu.be/3X2nkZCMIL8',
  },
  {
    title: 'AgriPix Image Options',
    url: 'https://youtu.be/xpY63_32pOY',
  },
  {
    title: 'AgriPix Image Generation',
    url: 'https://youtu.be/2fkuE0gjTyM',
  },
  {
    title: 'AgriPix Introduction',
    url: 'https://youtu.be/4ph7YBg8ILo',
  },
  {
    title: 'AgriPix Prompt Guidelines',
    url: 'https://youtu.be/Gt6DWzayZrI',
  },
];

const VideoList = () => {
  return (
    <div className="quick-reads-grid">
      {videoData.map((video, index) => (
        <VideoCard
          key={index}
          title={video.title}
          url={video.url}
        />
      ))}
    </div>
  );
};

export default VideoList;
